import React from 'react';
import * as Yup from "yup";
import { Paper, withStyles } from '@material-ui/core';
import NICForm from './NICForm'
import { BackButton, hasPermission, parseURL } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/nicActions";
import History from "../../../History";
const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }
});

const NICCreate = props => {
    const { permissions, activeCustomer, translations, classes } = props;
    let searchParams = parseURL(window.location.search);
    const handleSubmit = async data => {
        data['ProductID'] = searchParams.productID;
        let result = await props.onCreateNIC({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        ComponentType: "nic",
        Vendor: "",
        ComponentModel: '',
        SerialNumber: '',
        LogicalName: '',
        Capacity: 0,
        Description: ''
    };
    let formSettings = {
        Validation: {
            ComponentType: Yup.string().required("Required"),
            Vendor: Yup.string().required("Required"),
            ComponentModel: Yup.string().required("Required"),
            SerialNumber: Yup.string().required("Required"),
            Description: Yup.string().required("Required"),
            LogicalName: Yup.string().required("Required"),
            Capacity: Yup.number().required("Required"),
        },
        FormTitle: translations['create_nic_component'] || "Create nic component",
        ButtonSubmit: hasPermission(permissions, "component_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };
    return (
        <Paper className={classes.root}             >
            {BackButton(translations)}

            <NICForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
            ></NICForm>
        </Paper>
    )
}
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateNIC: nic => dispatch(actions.createNIC(nic)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(NICCreate));
